type CranePose = 'idle' | 'pointing' | 'celebrating' | 'sympathetic' | 'thinking';
type CraneSize = 'sm' | 'md' | 'lg';

interface CraneProps {
  pose?: CranePose;
  size?: CraneSize;
}

const sizeClasses = {
  sm: 'w-16 h-16',
  md: 'w-24 h-24',
  lg: 'w-40 h-40',
};

const poseImages: Record<CranePose, string> = {
  idle: '/CFHunts-PaperCrane-Idle.png',
  pointing: '/CFHunts-PaperCrane-Cluegiving.png',
  celebrating: '/CFHunts-PaperCrane-Celebrating.png',
  sympathetic: '/CFHunts-PaperCrane-Reassuring.png',
  thinking: '/CFHunts-PaperCrane-Thinking.png',
};

// Each pose gets its own motion so the crane feels alive and reactive.
const poseMotion: Record<CranePose, string> = {
  idle: 'animate-float',
  pointing: 'animate-float',
  celebrating: 'animate-celebrate',
  sympathetic: 'animate-wiggle',
  thinking: 'animate-sway',
};

/**
 * Crane Syntax - the origami paper crane mascot.
 * Folded from an old map, with cherry blossom accents.
 */
export function Crane({ pose = 'idle', size = 'md' }: CraneProps) {
  const imageSrc = poseImages[pose];

  return (
    <div className={`${sizeClasses[size]} relative ${poseMotion[pose]}`}>
      <img
        src={imageSrc}
        alt={`Crane mascot - ${pose}`}
        className="w-full h-full object-contain crane-shadow"
      />
    </div>
  );
}

/**
 * Crane with magnifying glass - for the magnifier clue type
 */
export function CraneWithMagnifier({ size = 'md' }: { size?: CraneSize }) {
  return (
    <div className={`${sizeClasses[size]} relative`}>
      <img
        src="/CFHunts-PaperCrane-MagnifyingGlass.png"
        alt="Crane mascot with magnifying glass"
        className="w-full h-full object-contain"
        loading="lazy"
      />
    </div>
  );
}
